/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

export type NumberFigureUnit = (typeof NumberFigureUnit)[keyof typeof NumberFigureUnit];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const NumberFigureUnit = {
  '%': '%',
  pp: 'pp',
  attempts: 'attempts',
  count: 'count',
} as const;
